<template>
  <button type="button" :class="compacto ? 'planilha-action' : 'btn btn-sm btn-gradient-success btn-icon mr-50'" :disabled="loading"
    title="gerar planilha" aria-label="gerar planilha" @click="exportar">
    <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-label="Gerando planilha" />
    <feather-icon v-else icon="GridIcon" size="16" />
  </button>
</template>

<script>
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  props: { pedidoId: { required: true }, referenciaBo: { type: String, default: '' }, compacto: { type: Boolean, default: false } },
  data: () => ({ loading: false }),
  methods: {
    async exportar() {
      if (this.loading) return;
      this.loading = true;
      try {
        const { data } = await axios.get(`pdf/gerarXlsxPedido/${encodeURIComponent(this.pedidoId)}`, {
          responseType: 'blob', params: this.referenciaBo ? { referenciaBo: this.referenciaBo } : {},
        });
        const url = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = `pedido-${String(this.referenciaBo || this.pedidoId).replace(/[^a-zA-Z0-9_-]/g, '')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 30000);
      } catch (error) {
        let message = 'Não foi possível exportar o pedido.';
        try {
          const data = error?.response?.data;
          message = (data instanceof Blob ? JSON.parse(await data.text()) : data)?.message || message;
        } catch (_) { /* Resposta sem JSON: mantém aviso. */ }
        this.$toast({ component: ToastificationContent, props: {
          title: 'Erro ao exportar planilha', text: message, variant: 'danger', icon: 'AlertTriangleIcon',
        } });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.planilha-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease;
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}
.planilha-action:hover { background: rgba(16, 185, 129, 0.2); }
.planilha-action:disabled { opacity: 0.65; cursor: wait; }
</style>
